"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/*
 @param {Array<Item<T>>} items
 @param {number} level The current depth (starting at 0)

 This function returns a single-depth array of items that have been flattened from an array of arrays.
 */

var flattenItems = function flattenItems(items) {
  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var flattenedItems = [];
  items.forEach(function (item) {
    flattenedItems.push(_objectSpread(_objectSpread({}, item), {}, {
      items: undefined,
      level: level
    }));
    if (item.items) {
      flattenedItems.push.apply(flattenedItems, (0, _toConsumableArray2["default"])(flattenItems(item.items, level + 1)));
    }
  });
  return flattenedItems;
};
var _default = flattenItems;
exports["default"] = _default;